type RequestOptions = Parameters<typeof fetch>[1];

function get(url: string, options?: RequestOptions) {
  return fetch(url, options);
}

export { get };
